/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const AuthLayout = () => {
  const [logoSrc, setLogoSrc] = useState<string>(toAbsoluteUrl('/media/logos/def-full.png'))

  useEffect(() => {
    const themeMode = document.documentElement.getAttribute('data-bs-theme')
    if (themeMode === 'light'){
      setLogoSrc(toAbsoluteUrl('/media/logos/def-full.png'))
    }
    else {
      setLogoSrc(toAbsoluteUrl('/media/logos/def-full.png'))
    }

    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])


  return (
    <div
      id='loginBg'
      className='d-flex flex-column flex-column-fluid bgi-position-center bgi-no-repeat bgi-size-cover bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/logos/authBg.jpeg')})`,
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Wrapper */}
        <div className='w-100' style={{maxWidth: '480px'}}>
          <div className='bg-white rounded shadow-lg px-10 px-lg-15 pb-10  mx-auto'>
            {/* begin::Logo */}
            <div className='text-center mb-4'>
              <img alt='Logo' src={logoSrc} className='w-400px h-120px' />
            </div>
            {/* end::Logo */}
            <Outlet />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      {/* <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='#' className='text-muted text-hover-primary px-2'>
            About
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact Us
          </a>
        </div>
      </div> */}
      {/* end::Footer */}
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
